import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import project1 from '../../images/project1.png'
import project2 from '../../images/project2.png'
import project3 from '../../images/project3.png'
import project4 from '../../images/project4.png'

import project5 from '../../images/project5.png'
import project6 from '../../images/project6.png'
import project7 from '../../images/project7.png'
import project8 from '../../images/project8.png'

import project9 from '../../images/project9.png'

import check_circle from '../../images/check-circle.png'


const projects = [
  {
    id: 1,
    title: "Reviving SEO & Building AI Visibility for a Plate Heat Exchanger Manufacturer",
    image: project1,
    stats: [
      { number: "100+", text: "We create responsive" },
      { number: "100+", text: "Drive results" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  },
  {
    id: 2,
    title: "Global Expansion & Growth for Aroma Monk",
    image: project2,
    stats: [
      { number: "200+", text: "Optimized performance" },
      { number: "300+", text: "Happy clients" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  },
  {
    id: 3,
    title: "B2B Pharma SEO Turnaround for a Private-Label Manufacturer",
    image: project3,
    stats: [
      { number: "50+", text: "Modern UI" },
      { number: "80+", text: "Custom branding" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  },
  {
    id: 4,
    title: "Export-Ready Website & AI-First SEO for GNC Exports",
    image: project4,
    stats: [
      { number: "50+", text: "Modern UI" },
      { number: "80+", text: "Custom branding" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  },
  {
    id: 5,
    title: "Organic Growth & CAC Reduction for Ease My Hotel (SaaS)",
    image: project5,
    stats: [
      { number: "50+", text: "Modern UI" },
      { number: "80+", text: "Custom branding" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  },
  {
    id: 6,
    title: "Dual-Sided Growth for a SaaS Influencer Marketing Platform (US)",
    image: project6,
    stats: [
      { number: "50+", text: "Modern UI" },
      { number: "80+", text: "Custom branding" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  },
  {
    id: 7,
    title: "Global Expansion & Export Lead Growth for Farmoduct (Agri Exports)",
    image: project7,
    stats: [
      { number: "50+", text: "Modern UI" },
      { number: "80+", text: "Custom branding" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  },
  {
    id: 8,
    title: "Local & B2B SEO Expansion for a Singapore Kitchen Cabinet Brand",
    image: project8,
    stats: [
      { number: "50+", text: "Modern UI" },
      { number: "80+", text: "Custom branding" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  },
  {
    id: 9,
    title: "Local Authority & Year-Round Lead Growth for Arrow Gifter (Corporate Gifting)",
    image: project9,
    stats: [
      { number: "50+", text: "Modern UI" },
      { number: "80+", text: "Custom branding" },
    ],
    feature: [
      {text: "Free website migration" },
      {text: "Free SEO Audit" },
      {text: "24/7 customer support" },
    ],
    description: "",
  }
];

export default function ProjectShowcaseSlider() {
  const [activeProject, setActiveProject] = useState(projects[0]);

  return (

    <>
    <section className="business_consulting_service_section section_space">
        <div className="container container_max">
        <div className="heading_block text-center">
            <span className="sub_heading">PROJECTS</span>
            <br/>
            <br/>
            <div className="heading_block">
              <h2 className="heading_text heading_top">Case Study</h2>
            </div>
        </div>
        <div className="row gap-10">
            {/* Left Project List */}
            <div className="col-lg-4 col-md-12">
                <ul className="space-y-2 project_list">
                    {projects.map((project) => (
                        <li
                            key={project.id}
                            className={`rounded-lg transition-colors cursor-pointer ${
                                activeProject.id === project.id
                                    ? "active_li"
                                    : "hover:bg-blue-50 text-gray-500"
                            }`}
                            onClick={() => setActiveProject(project)}
                        >
                            <a href="javascript:void(0)">{project.title}</a>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Right Project Content */}
            <div className="col-lg-8 col-md-12">
                <AnimatePresence mode="wait">
                <motion.div
                     key={activeProject.id}
                    initial={{ opacity: 0, y: 50 }}   // Slide in from top
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -50 }}      // Slide out to bottom
                    transition={{ duration: 0.5 }}
                    className="space-y-6"
                >
                <div className="row">
                    <div className="col-lg-12 col-md-12 text-center">
                        <div className="section_title">
                            <h2>{activeProject.title}</h2>
                        </div>
                    </div>
                   
                    <div className="col-lg-12 col-md-12">
                        <img src={activeProject.image}/>
                    </div>

                    <div className="col-lg-12 col-md-12">
                        <ul className="space-y-2 feature_list">
                             {activeProject.feature.map((item, i) => (
                                <li><p><img src={check_circle}/>&nbsp;&nbsp;{item.text}</p></li>
                            ))}                            
                        </ul>
                    </div>

                    <div className="col-lg-12 col-md-12">
                       <p>{activeProject.description}</p>
                    </div>

                </div>
    
                </motion.div>
                </AnimatePresence>
            </div>
            </div>
        </div>
    </section>
    </>
  );
}
